import {
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { Controller, useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import axios from "../axios";
import { queryClient } from "../index";

const EditParentForm = ({ parent }) => {
  const { id } = useParams();
  const { control, handleSubmit } = useForm({
    defaultValues: {
      fullName: parent.fullName || "",
      identificationNumber: parent.identificationNumber || "",
      phone: parent.phone || "",
      email: parent.email || "",
      address: parent.address || "",
      isActive: parent.isActive,
    },
  });

  const updateParentMutation = useMutation((data) =>
    axios.put(`/parents/${id}`, data)
  );

  const handleFormSubmission = (data) => {
    updateParentMutation.mutate(data, {
      onSuccess: () => {
        queryClient.invalidateQueries(["parent", id]);
        queryClient.invalidateQueries("parents");
        toast.success("Parent updated successfully");
      },
      onError: () => {
        toast.error("Error updating parent");
      },
    });
  };

  return (
    <div>
      <Typography mb={2} variant="h5" component="h2">
        Edit Parent
      </Typography>
      <Box
        onSubmit={handleSubmit(handleFormSubmission)}
        component="form"
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)" },
          gap: 2,
        }}
        autoComplete="off"
      >
        <Controller
          render={({ field }) => (
            <TextField {...field} required label="Full name" />
          )}
          control={control}
          name="fullName"
        />
        <Controller
          render={({ field }) => (
            <TextField {...field} required label="Identification number" />
          )}
          control={control}
          name="identificationNumber"
        />
        <Controller
          render={({ field }) => (
            <TextField {...field} required label="Phone" />
          )}
          control={control}
          name="phone"
        />
        <Controller
          render={({ field }) => (
            <TextField {...field} label="Email" type="email" />
          )}
          control={control}
          name="email"
        />
        <Controller
          render={({ field }) => (
            <TextField
              {...field}
              required
              label="Address"
              minRows={4}
              multiline
              sx={{ gridColumn: { sm: "span 2" } }}
            />
          )}
          control={control}
          name="address"
        />
        <Controller
          render={({ field }) => (
            <FormControlLabel
              control={
                <Checkbox
                  checked={!!field.value}
                  onChange={(event) => field.onChange(event.target.checked)}
                />
              }
              label="Active"
            />
          )}
          control={control}
          name="isActive"
        />
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            type="submit"
            variant="contained"
            disabled={updateParentMutation.isLoading}
          >
            {updateParentMutation.isLoading ? "Updating..." : "Update Parent"}
          </Button>
        </Box>
      </Box>
    </div>
  );
};

const EditParent = () => {
  const { id } = useParams();
  const {
    data: parent,
    isLoading,
    isError,
  } = useQuery(["parent", id], () =>
    axios.get(`/parents/${id}`).then((res) => res.data)
  );

  if (isLoading) return <CircularProgress />;
  if (isError || !parent) return <Typography>Parent not found</Typography>;

  return <EditParentForm parent={parent} />;
};

export default EditParent;
